<template>
    <div class="rel p:1 z:10 w:full {content:'';abs;bg:linear-gradient(290.86deg,rgba(248,195,233,0.99)|0%,#C1DDFF|25.49%,#CAE3F3|78.2%,#EFE8AC|100.77%);w:100%;h:100%;top:0;left:0;z:-1;r:100}::before {r:20}::before@<sm">
        <div class="r:100 p:16|32 bg:#E0EAFF {r:20;p:12|16}@<sm">
            <part-search class="flex px:8 r:8 bg:white w:full" v-bind="$attrs"></part-search>
        </div>
    </div>
</template>
